const apk = false;

const enVars = {
  environment: apk ? 'apk' : process.env.NODE_ENV, // values => development | production

  production: {
    API_URL: 'https://xolanihealth.cloud',
    API_URL2: 'https://server.xolanihealth.cloud/api/v1',
    ORTHANC_URL: 'https://xolaniserver.live',
  },
  development: {
    API_URL: 'https://xolanihealth.cloud',
    API_URL2: 'https://server.xolanihealth.cloud/api/v1',
    ORTHANC_URL: 'https://xolaniserver.live',
  },
};

const env = {
  ENVIRONMENT: enVars.development,
  ...(enVars.environment === 'production'
    ? process.env.REACT_APP_ENV === 'development'
      ? enVars.development
      : enVars.production
    : enVars.development),
};

export default env;
